var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M12 24C18.6353 24 24 18.6353 24 12C24 5.36471 18.6353 0 12 0C5.36471 0 0 5.36471 0 12C0 18.6353 5.36471 24 12 24Z",
    fill: "#1C2541"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10583 9.95294H10.3764V8.75294C10.3764 8.18823 10.3764 7.41176 10.8 6.91765C11.1529 6.35294 11.7176 6 12.7058 6C14.2588 6 14.9647 6.21176 14.9647 6.21176L14.6823 8.04706C14.6823 8.04706 14.1882 7.90588 13.6941 7.90588C13.2 7.90588 12.7764 8.04706 12.7764 8.54118V9.95294H14.7529L14.6117 11.7176H12.7058V17.9294H10.3764V11.7176H9.10583V9.95294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.14f471857667d05dc288b2d3a627d7e2.svg";
export { ForwardRef as ReactComponent };